<template>
  <div class="match-block">
    <font-awesome-icon :icon="['fas','long-arrow-alt-up']" size="1x" class="has-text-success"/>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faLongArrowAltUp } from '@fortawesome/pro-solid-svg-icons';

library.add(faLongArrowAltUp);

export default {
};
</script>

<style lang="sass" scoped>
  @import "@/sass/custom.sass"

  .fa-long-arrow-alt-up
    color: $success
</style>
